import { useState, useEffect } from "react";
import MainLayouts from "../../Layout/MainLayouts";
import { ReactComponent as ArrowLeftSquare } from "bootstrap-icons/icons/arrow-left-square-fill.svg";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { ReactComponent as BiNewspaper } from "bootstrap-icons/icons/newspaper.svg";
import Spinner from "../spinner/Spinner";
import { Link, useNavigate, useLocation } from "react-router-dom";
import CurrencyFormatter from "../../components/utils/CurrencyFormatter";

import formatDate from "../../components/utils/DateFormatter";
const VendorWithdrawalDetails = () => {
  const [withdrawalDetails, setWithdrawalDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  const location = useLocation();
  const { data } = location.state || {};


  useEffect(() => {
    // console.log("my data",data);
    if (data) {
      setWithdrawalDetails(data);
    }
    setLoading(false);
  }, [data]);

  if (loading) {
    return (
      <MainLayouts>
        <Spinner loading={loading} />
      </MainLayouts>
    );
  }

  if (!withdrawalDetails) {
    return (
      <MainLayouts>
        <div className="p-6">
          <h2 className="text-red-500">No withdrawal details found.</h2>
          <button
            onClick={() => navigate(-1)}
            className="mt-4 bg-darkGreen3 text-white px-4 py-2 rounded-lg"
          >
            Go Back
          </button>
        </div>
      </MainLayouts>
    );
  }

  return (
    <MainLayouts>
      <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
        {/* Breadcrumb */}
        <section
          className="w-full pl-[3%] pr-[3%] pt-3 my-3"
          style={{ backgroundColor: "#F7F7F7" }}
        >
          <nav className="bg-gray-200 py-0 px-4 rounded-lg ">
            <ol className="list-none p-0 inline-flex mb-2">
              <li className="flex items-center">
                <p className="text-darkGreen3 pr-2">Withdrawal</p>
                <ChevronRightIcon />
              </li>
              <li className="flex items-center">
                <p className="text-orange1">Details</p>
              </li>
            </ol>
          </nav>
        </section>

        {/* Details section */}
        <section className="text-gray-600 body-font">
          <div className="container px-1 py-1 mx-auto">
            <div className="flex flex-wrap -m-2">
              <div className="p-2 w-full">
                <div className="h-full flex border-grey3 border items-center p-4 rounded-lg">
                  <div className="flex-grow">
                    <h2 className="text-dash title-font font-medium">
                      Reference:{" "}
                      {withdrawalDetails.reference || "NOT AVAILABLE"}
                    </h2>
                    <p className="text-gray-500">
                      Status:{" "}
                      <span
                        className={`px-2 py-1 rounded ${(withdrawalDetails.status || "").toLowerCase() === "rejected"
                          ? "bg-dash3 text-lGrey"
                          : (withdrawalDetails.status || "").toLowerCase() === "approved"
                            ? "bg-darkGreen3 text-lGrey"
                            : "bg-dash4 text-lGrey"
                          }`}
                      >
                        {withdrawalDetails.status || "NOT AVAILABLE"}
                      </span>

                    </p>
                  </div>
                </div>
              </div>

              {/* Withdrawal info box */}
              <div className="px-2 w-full">
                <div className="h-full flex items-center border-dash border p-2 rounded-lg border-l-4">
                  <div className="w-full pb-6">
                    <div className="flex border-gray-200 py-2">
                      <span className="text-gray-500">Amount</span>
                      <span className="ml-auto text-dash">
                        {CurrencyFormatter(withdrawalDetails.amount) || "0.00"}
                      </span>
                    </div>

                    <div className="flex border-t border-grey3 py-2">
                      <span className="text-gray-500">Processing Fee</span>
                      <span className="ml-auto text-dash">
                        {CurrencyFormatter(withdrawalDetails.processing_fee) || "0.00"}
                      </span>
                    </div>

                    <div className="flex border-t border-grey3 py-2">
                      <span className="text-gray-500">Net Amount</span>
                      <span className="ml-auto text-dash">
                        {CurrencyFormatter(withdrawalDetails.net_amount) || "0.00"}
                      </span>
                    </div>

                    <div className="flex border-t border-grey3 py-2">
                      <span className="text-gray-500">Method</span>
                      <span className="ml-auto text-dash capitalize">
                        {withdrawalDetails.withdrawal_method.replace("_", " ")}
                      </span>
                    </div>

                    <div className="flex border-t border-grey3 py-2">
                      <span className="text-gray-500">Description</span>
                      <span className="ml-auto text-dash">
                        {withdrawalDetails.description || "NOT AVAILABLE"}
                      </span>
                    </div>

                    <div className="flex border-t border-grey3 py-2">
                      <span className="text-gray-500">Bank Details</span>
                      <span className="ml-auto text-dash">
                        {withdrawalDetails.bank_details
                          ? `${withdrawalDetails.bank_details.account_name} - ${withdrawalDetails.bank_details.bank_name} (${withdrawalDetails.bank_details.account_number})`
                          : "NOT AVAILABLE"}
                      </span>
                    </div>

                    <div className="flex border-t border-grey3 py-2">
                      <span className="text-gray-500">Admin Reference</span>
                      <span className="ml-auto text-dash">
                        {withdrawalDetails.admin_reference || "NOT AVAILABLE"}
                      </span>
                    </div>

                    <div className="flex border-t border-grey3 py-2">
                      <span className="text-gray-500">Rejection Reason</span>
                      <span className="ml-auto text-dash">
                        {withdrawalDetails.rejection_reason || "NOT AVAILABLE"}
                      </span>
                    </div>

                    <div className="flex border-t border-grey3 py-2">
                      <span className="text-gray-500">Admin Notes</span>
                      <span className="ml-auto text-dash">
                        {withdrawalDetails.admin_notes || "NOT AVAILABLE"}
                      </span>
                    </div>

                    <div className="flex border-t border-grey3 py-2">
                      <span className="text-gray-500">Processed By</span>
                      <span className="ml-auto text-dash">
                        {withdrawalDetails.processed_by || "NOT AVAILABLE"}
                      </span>
                    </div>

                    <div className="flex border-t border-grey3 py-2">
                      <span className="text-gray-500">Processed Date</span>
                      <span className="ml-auto text-dash">
                        {withdrawalDetails.processed_at ? formatDate(withdrawalDetails.processed_at) : "NOT AVAILABLE"}
                      </span>
                    </div>

                    <div className="flex border-t border-grey3 py-2">
                      <span className="text-gray-500">Date created</span>
                      <span className="ml-auto text-dash">
                        {withdrawalDetails.created_at ? formatDate(withdrawalDetails.created_at) : "NOT AVAILABLE"}
                      </span>
                    </div>


                  </div>
                </div>
              </div>

              {/* Back button */}
              <div className="ml-auto w-[25%] flex justify-end my-4">
                <Link
                  to="/admin/vendor/withdrawal/request"
                  className="w-full sm:w-auto text-dGrey3 bg-darkGreen3 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                >
                  <span className="flex justify-center sm:justify-start mx-2">
                    <ArrowLeftSquare className="mr-2" />
                    Back
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </MainLayouts>
  );
};

export default VendorWithdrawalDetails;
